!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("classnames"));else if ("function" == typeof define && define.amd) define(["react", "classnames"], t);else {
    var r = "object" == typeof exports ? t(require("react"), require("classnames")) : t(e.react, e.classnames);
    for (var n in r) ("object" == typeof exports ? exports : e)[n] = r[n];
  }
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) r.d(n, a, function (t) {
        return e[t];
      }.bind(null, a));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 145);
  }({
    0: function _(t, r) {
      t.exports = e;
    },
    1: function _(e, r) {
      e.exports = t;
    },
    145: function _(e, t, r) {
      "use strict";

      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var a = n(r(146));
      t.Body1 = a.default({
        classModifier: "body1",
        tag: "p"
      }), t.Body2 = a.default({
        classModifier: "body2",
        tag: "p"
      }), t.Button = a.default({
        classModifier: "button",
        tag: "span"
      }), t.Caption = a.default({
        classModifier: "caption",
        tag: "span"
      }), t.Headline1 = a.default({
        classModifier: "headline1",
        tag: "h1"
      }), t.Headline2 = a.default({
        classModifier: "headline2",
        tag: "h2"
      }), t.Headline3 = a.default({
        classModifier: "headline3",
        tag: "h3"
      }), t.Headline4 = a.default({
        classModifier: "headline4",
        tag: "h4"
      }), t.Headline5 = a.default({
        classModifier: "headline5",
        tag: "h5"
      }), t.Headline6 = a.default({
        classModifier: "headline6",
        tag: "h6"
      }), t.Overline = a.default({
        classModifier: "overline",
        tag: "span"
      }), t.Subtitle1 = a.default({
        classModifier: "subtitle1",
        tag: "h6"
      }), t.Subtitle2 = a.default({
        classModifier: "subtitle2",
        tag: "h6"
      });
    },
    146: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var r = {};
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var a = 0;
            for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
          }
          return r;
        },
        i = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = i(r(1)),
        l = i(r(0));
      t.default = function (e) {
        var t = e.tag,
          r = e.classModifier;
        return function (e) {
          var i = e.children,
            s = e.className,
            u = void 0 === s ? "" : s,
            f = e.tag,
            d = void 0 === f ? t : f,
            c = a(e, ["children", "className", "tag"]),
            p = o.default("mdc-typography", "mdc-typography--" + r, u);
          return l.default.createElement(d, n({
            className: p
          }, c), i);
        };
      };
    }
  });
});